
export const faqs = [
  {
    question: "How can I start recycling with Chanja Datti?",
    answer:
      "You can start by signing up on our platform and scheduling a pickup or visiting any of our recycling hubs.",
  },
  {
    question: "Do I get paid when I recycle with Chanja Datti?",
    answer:
      "Yes. You get paid whenever you request for pickup or bring waste into any of our recycling hubs.",
  },
  {
    question: "How can I locate a recycling hub close to me?",
    answer:
      "Use the hub locator on our website or contact our support team for assistance.",
  },
  {
    question: "How can I become a volunteer for Chanja Datti?",
    answer:
      "You can apply through the volunteer section on our website and our team will reach out.",
  },
];